import { Typography } from "antd";
import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  & > svg {
    margin-bottom: 8px;
  }

  .text {
    width: 352px;
    text-align: center;
    font-weight: 500;
  }
`;

export const GrayText = styled(Typography.Text)`
  color: ${"#bfbfbf"};
`;

export const BlueText = styled(Typography.Text)`
  color: ${"#1677ff"};
`;

export const ResponsibleItem = styled.div`
  text-align: center;

  > ${BlueText} > a {
    width: fit-content;
  }
`;
